import { render, staticRenderFns } from "./ManaginTag.vue?vue&type=template&id=7588ab3d&scoped=true&"
import script from "./ManaginTag.vue?vue&type=script&lang=ts&"
export * from "./ManaginTag.vue?vue&type=script&lang=ts&"
import style0 from "./ManaginTag.vue?vue&type=style&index=0&id=7588ab3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588ab3d",
  null
  
)

export default component.exports